import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import styled from 'styled-components'

const DiscontinuedItemInQuoteSubComponent = ({ closeHandler, continueHandler }) =>
  <ButtonWrapper>
    <Button bolder onClick={ closeHandler }>
      Cancel
    </Button>
    <Button bolder onClick={ continueHandler }>
      Remove inactive products and continue
    </Button>
  </ButtonWrapper>

export default DiscontinuedItemInQuoteSubComponent

DiscontinuedItemInQuoteSubComponent.propTypes = {
  closeHandler: PropTypes.func,
  continueHandler: PropTypes.func
}

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: right;
  margin-top: 40px;
  ${Media.mobile`
    ${Button} {
      width: 100%;
      margin-bottom: 20px;
      margin-left: 0;
    }
  `}
`
